export const fonts = (fontFamily?: string) => {
  const hasElementFont = document.getElementById("fonts");
  const font = Boolean(fontFamily) ? fontFamily : "Nunito";
  const newFont = `https://fonts.googleapis.com/css2?family=${font}:wght@200;300;400;500;600;700;800;900;1000&display=swap`;
  if (!hasElementFont) {
    const linkElement = document.createElement("link");

    linkElement.setAttribute("id", "fonts");
    linkElement.setAttribute("rel", "stylesheet");
    linkElement.setAttribute("href", newFont);

    document.head.appendChild(linkElement);
  } else {
    hasElementFont.setAttribute("href", newFont);
  }
};

export const title = (title?: string) => {
  const hasElementTitle = document.getElementById("title");

  if (!hasElementTitle) {
    const titleElement = document.createElement("title");
    titleElement.setAttribute("id", "title");
    titleElement.textContent = title || "";

    document.head.appendChild(titleElement);
  } else {
    hasElementTitle.textContent = title || "";
  }
};

export const icon = (url?: string) => {
  const linkElement = document.createElement("link");
  linkElement.setAttribute("rel", "icon");
  linkElement.setAttribute("type", "image/png");
  linkElement.setAttribute("href", url || "");

  document.head.appendChild(linkElement);
};
